const getAnchorLinksFromTextSectionContent = (textSectionContent) => {
  const textTypesToInclude = [
    "title_with_xl_v2",
    "title_with_xl",
    "title_v2",
    "title",
    "heading_v2",
    "heading",
    "subheading_v2",
    "subheading",
    "subtitle"
  ];
  const levelMap = {
    title_with_xl_v2: 1,
    title_with_xl: 1,
    title_v2: 1,
    title: 1,
    heading_v2: 2,
    heading: 2,
    subheading_v2: 3,
    subheading: 3,
    subtitle: 3
  };
  const links = [];
  textSectionContent == null ? void 0 : textSectionContent.forEach((textSection) => {
    const text = textSection.markdown_text;
    const type = textSection.select_text_type;
    if (text && textTypesToInclude.includes(type)) {
      links.push({
        text,
        type,
        level: levelMap[type]
      });
    }
  });
  return links;
};
export {
  getAnchorLinksFromTextSectionContent
};
